module.exports = __webpack_public_path__ + "impact-35d8306a636b974fed846fcef6146572.png";